export const stringFormatter = (str: string): string => {
  return str.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
};

export const rusLettersReg = /^[а-яА-ЯёЁ]+$/;
